
import React, { useState } from 'react';  
import { Link, useNavigate } from 'react-router-dom';  
import { useAuth } from '../../context/AuthContext';  
import { FiMail, FiLock, FiEye, FiEyeOff, FiArrowRight, FiAlertCircle, FiHome, FiBarChart2, FiUsers, FiFileText } from 'react-icons/fi';  
import './auth.css';  
  
const LoginPage = () => {  
  const [email, setEmail] = useState('');  
  const [password, setPassword] = useState('');  
  const [showPassword, setShowPassword] = useState(false);  
  const [rememberMe, setRememberMe] = useState(false);  
  const [error, setError] = useState('');  
  const [loading, setLoading] = useState(false);  
  const { login } = useAuth();  
  const navigate = useNavigate();  
  
  const handleSubmit = async (e) => {  
    e.preventDefault();  
    setError('');  
    setLoading(true);  
    try {  
      const res = await login(email, password);  
      if (res?.user?.role === 'super-admin') {
        navigate('/admin/dashboard');
      } else if (res?.user?.role === 'locataire' || res?.user?.role === 'client') {
        navigate('/portal/dashboard');
      } else {
        navigate('/dashboard');  
      }
    } catch (err) {  
      setError(err.response?.data?.error || 'Email ou mot de passe incorrect');  
    } finally {  
      setLoading(false);  
    }  
  };  
  
  return (  
    <div className="auth-wrapper">  
      {/* Panneau gauche */}  
      <div className="auth-left">  
        <div className="auth-left-content">  
          <div className="auth-brand">  
            <div className="auth-brand-icon">🏢</div>  
            <div className="auth-brand-name">Gestion<span>Immo</span></div>  
          </div>  
          <h2>Gérez votre patrimoine immobilier avec intelligence</h2>  
          <p>La plateforme SaaS complète pour les agences immobilières africaines. Contrats, loyers, annonces et bien plus.</p>  
          <ul className="auth-features-list">  
            <li>  
              <div className="auth-feature-icon"><FiHome size={16} /></div>  
              Gestion complète des biens immobiliers  
            </li>  
            <li>  
              <div className="auth-feature-icon"><FiFileText size={16} /></div>  
              Cycle locatif automatisé (contrats, loyers, relances)  
            </li>  
            <li>  
              <div className="auth-feature-icon"><FiBarChart2 size={16} /></div>  
              Rapports financiers et tableaux de bord  
            </li>  
            <li>  
              <div className="auth-feature-icon"><FiUsers size={16} /></div>  
              CRM intégré pour clients et prospects  
            </li>  
          </ul>  
          <div className="auth-stats-row">  
            <div className="auth-stat">  
              <span className="auth-stat-value">500+</span>  
              <span className="auth-stat-label">Agences</span>  
            </div>  
            <div className="auth-stat">  
              <span className="auth-stat-value">12k+</span>  
              <span className="auth-stat-label">Biens gérés</span>  
            </div>  
            <div className="auth-stat">  
              <span className="auth-stat-value">98%</span>  
              <span className="auth-stat-label">Satisfaction</span>  
            </div>  
          </div>  
        </div>  
      </div>  
  
      {/* Panneau droit */}  
      <div className="auth-right">  
        <div className="auth-right-header">  
          <h1>Bon retour 👋</h1>  
          <p>Connectez-vous à votre espace de gestion immobilière</p>  
        </div>  
  
        {error && (  
          <div className="auth-alert-error">  
            <FiAlertCircle size={16} />  
            {error}  
          </div>  
        )}  
  
        <form className="auth-form" onSubmit={handleSubmit}>  
          <div className="form-group">  
            <label>Adresse email</label>  
            <div className="auth-input-wrapper">  
              <FiMail size={16} className="auth-input-icon" />  
              <input  
                type="email"  
                className="form-control"  
                value={email}  
                onChange={e => setEmail(e.target.value)}  
                placeholder="votre@email.com"  
                required  
                autoComplete="email"  
              />  
            </div>  
          </div>  
  
          <div className="form-group">  
            <label>Mot de passe</label>  
            <div className="auth-input-wrapper">  
              <FiLock size={16} className="auth-input-icon" />  
              <input  
                type={showPassword ? 'text' : 'password'}  
                className="form-control"  
                value={password}  
                onChange={e => setPassword(e.target.value)}  
                placeholder="••••••••"  
                required  
                autoComplete="current-password"  
              />  
              <button  
                type="button"  
                className="auth-password-toggle"  
                onClick={() => setShowPassword(!showPassword)}  
                tabIndex={-1}  
              >  
                {showPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}  
              </button>  
            </div>  
          </div>  
  
          <div className="auth-form-options">  
            <label className="auth-remember">  
              <input  
                type="checkbox"  
                checked={rememberMe}  
                onChange={e => setRememberMe(e.target.checked)}  
              />  
              Se souvenir de moi  
            </label>  
            <Link to="/forgot-password" className="auth-forgot">Mot de passe oublié ?</Link>  
          </div>  
  
          <button type="submit" className="auth-btn-primary" disabled={loading}>  
            {loading ? (  
              <>  
                <span style={{ width: 16, height: 16, border: '2px solid rgba(255,255,255,0.3)', borderTopColor: 'white', borderRadius: '50%', animation: 'spin 0.8s linear infinite', display: 'inline-block' }} />  
                Connexion en cours...  
              </>  
            ) : (  
              <>  
                Se connecter  
                <FiArrowRight size={18} />  
              </>  
            )}  
          </button>  
        </form>  
  
        <div className="auth-divider">ou</div>  
  
        <div className="auth-footer-link">  
          Pas encore de compte ?{' '}  
          <Link to="/register">Créer un compte gratuitement</Link>  
        </div>  
  
        <div className="auth-footer-link" style={{ marginTop: 12 }}>  
          <Link to="/" style={{ color: 'var(--auth-gray)', fontSize: 13 }}>← Retour à l'accueil</Link>  
        </div>  
      </div>  
    </div>  
  );  
};  
  
export default LoginPage;
